import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, AlertCircle, CheckCircle2, Loader2, ArrowLeft } from "lucide-react";
import AuthShell from "../../components/AuthShell";
import { api } from "../../lib/api";
import { formatApiErrorDetail } from "../../lib/constants";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!email) {
      setError("Please enter your email.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/customer/request-password-reset", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Reset password" subtitle="We'll email you a secure reset link.">
      {sent ? (
        <div data-testid="reset-sent-message" className="rounded-xl bg-[#DCFCE7] border border-[#BBF7D0] px-4 py-4 text-[#166534]">
          <CheckCircle2 size={22} className="mb-2" />
          <p className="font-semibold">Check your inbox</p>
          <p className="text-sm mt-1">If an account exists for {email}, a reset link is on its way. It expires in 1 hour.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          {error && (
            <div data-testid="forgot-error" className="flex items-start gap-2 rounded-xl bg-[#FFF0F0] border border-[#FFD0D0] px-4 py-3 text-sm text-[#991B1B]">
              <AlertCircle size={18} className="shrink-0 mt-0.5" />
              <span>{error}</span>
            </div>
          )}
          <div className="relative">
            <Mail size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
            <input
              data-testid="forgot-email-input"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full h-[52px] pl-11 pr-4 rounded-xl bg-gray-100 focus:bg-white border border-transparent focus:border-[#228B22] outline-none transition-colors"
            />
          </div>
          <button
            data-testid="forgot-submit-button"
            type="submit"
            disabled={loading}
            className="w-full h-[52px] rounded-full bg-[#228B22] hover:bg-[#1A4331] text-white font-semibold transition-colors duration-200 flex items-center justify-center disabled:opacity-60"
          >
            {loading ? <Loader2 size={20} className="animate-spin" /> : "Send Reset Link"}
          </button>
        </form>
      )}
      <Link to="/login" className="mt-6 inline-flex items-center gap-1 text-sm text-gray-500 hover:text-[#228B22]">
        <ArrowLeft size={16} /> Back to sign in
      </Link>
    </AuthShell>
  );
}
